<template>
  <div class="allbox">
    <el-table :data="ocpcInfo" style="width: 100%;" border>
      <el-table-column
        prop="label"
        label="字段名"
        width="200px"
      />
      <el-table-column
        prop="value"
        label="值"
      >
        <template v-slot="scope">
          {{ scope.row.value }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    ocpc_info: {
      type: Object
    }
  },
  data() {
    return {
      labelMapping: [
        { key: 'useRoiText', label: '使用ROI优化' },
        { key: 'ocpcBid', label: '目标转化出价' },
        { key: 'roiRatio', label: 'ROI转化率' },
        { key: 'ocpcLevel', label: '当前处于ocpc第几阶段' },
        { key: 'transName', label: '转化名称' },
        { key: 'transTypeText', label: '目标转化' },
        { key: 'transTargetTypeText', label: '转化目标类型' },
        { key: 'appTransId', label: '转化追踪ID' },
        { key: 'monitorUrl', label: '点击检测地址' },
        { key: 'transTypeName', label: '目标转化名称' },
        { key: 'urlTypeText', label: '落地页类型' },
        { key: 'transFromText', label: '接入方式' },
        { key: 'isNewVersionText', label: '是否新版' },
        { key: 'deepOcpcStatusText', label: '深度转换状态' },
        { key: 'isSkipStageOneText', label: '是否步过第一阶段' },
        { key: 'isOptimizeDeepTransText', label: '是否优化深度转化' },
        { key: 'lpUrl', label: '推广url' },
        { key: 'isManualBidForMaxModeText', label: '是否手动出价最大模式' },
        { key: 'isManualDeepBidForMaxModeText', label: '是否手动深度出价最大模式' }
      ],
      ocpcInfo: []
    }
  },
  watch: {
    ocpc_info: {
      immediate: true,
      handler(val) {
        this.sendr(val)
      }
    }
  },
  created() {},
  methods: {
    sendr(row) {
      this.ocpcInfo = this.labelMapping
        // eslint-disable-next-line no-prototype-builtins
        .filter(item => row.hasOwnProperty(item.key))
        .map(item => {
          return {
            label: item.label,
            value: row[item.key] || ''
          }
        })
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}
</style>
